import * as moment from "moment/moment";

function startOfCalendarDay(value: any): moment.Moment {
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return moment(value, "YYYY-MM-DD", true).startOf("day");
  }
  return moment(value).startOf("day");
}

export function getAccommodationPerDate(day: any, accommodationsArr: any[]): any[] {
  const accommodations = [];
  for (const accommodation of accommodationsArr) {
    const date = startOfCalendarDay(day);
    const checkIn = startOfCalendarDay(accommodation.checkIn);
    let checkOut = startOfCalendarDay(accommodation.checkOut);

    // Adjust the checkOut date only if it's not the same as the date (current day)
    if (!checkOut.isSame(checkIn)) {
      checkOut = checkOut.subtract(1, "day");
    }

    if (date.isSameOrAfter(checkIn) && date.isSameOrBefore(checkOut)) {
      accommodations.push(accommodation);
    }
  }
  return accommodations;
}

export function isDateInRange(givenDate: any, checkIn: any, checkOut: any): boolean {
  const g     = startOfCalendarDay(givenDate);
  const start = startOfCalendarDay(checkIn);
  const end   = startOfCalendarDay(checkOut);

  // if checkIn and checkOut are the same day, allow exactly that day
  if (!end.isAfter(start)) {
    return g.isSame(start);
  }

  // otherwise include start, exclude end
  return g.isSameOrAfter(start) && g.isBefore(end);

}


